{
  "TEAMS_SETTINGS": {
    "NEW_TEAM": "إنشاء فريق جديد",
    "HEADER": "الفرق",
    "LOADING": "Fetching teams",
    "DESCRIPTION": "الفرق تتيح لك تنظيم الوكلاء في مجموعات بناءً على مسؤولياتهم. يمكن للوكيل أن يكون عضوًا في أكثر من فريق. لتحقيق التعاون في العمل, يمكنك إسناد المحادثات لفرق محددة.",
    "LEARN_MORE": "لمعرفة المزيد حول الفرق",
    "LIST": {
      "404": "لا يوجد موظفي دعم مرتبطين بهذا الحساب.",
      "EDIT_TEAM": "تعديل الفريق",
      "NONE": "لا شيء"
    },
    "CREATE_FLOW": {
      "CREATE": {
        "TITLE": "إنشاء فريق جديد",
        "DESC": "أضف عنوانا ووصفا إلى فريقك الجديد."
      },
      "AGENTS": {
        "BUTTON_TEXT": "إضافة وكيل للفريق",
        "TITLE": "إضافة وكلاء للفريق - {teamName}",
        "DESC": "إضافة وكلاء إلى فريقك الجديد. هذا يتيح لكم العمل كفريق في المحادثات، والحصول على إشعار عن الأحداث الجديدة في نفس المحادثة."
      },
      "WIZARD_CREATE": {
        "TITLE": "إنشاء",
        "BODY": "إنشاء فريق جديد للوكلاء."
      },
      "WIZARD_ADD_AGENTS": {
        "TITLE": "إضافة وكلاء",
        "BODY": "إضافة وكيل إلى فريق."
      },
      "WIZARD_FINISH": {
        "TITLE": "إنهاء",
        "BODY": "أصبح كل شيء جاهزاً الآن!"
      }
    },
    "EDIT_FLOW": {
      "CREATE": {
        "TITLE": "تحرير تفاصيل فريقك",
        "DESC": "تعديل العنوان والوصف إلى فريقك.",
        "BUTTON_TEXT": "تحديث فريق"
      },
      "AGENTS": {
        "BUTTON_TEXT": "تحديث الوكلاء في الفريق",
        "TITLE": "إضافة وكلاء للفريق - {teamName}",
        "DESC": "إضافة وكلاء إلى فريقك الذي تم إنشاؤه حديثاً. سيتم إعلام جميع الوكلاء المضافين عند تعيين محادثة لهذا الفريق."
      },
      "EDIT_WIZARD_DETAILS": {
        "TITLE": "تفاصيل الفريق",
        "ROUTE": "settings_teams_edit",
        "BODY": "تغيير الاسم والوصف والتفاصيل الأخرى."
      },
      "EDIT_WIZARD_AGENTS": {
        "TITLE": "تعديل الوكلاء",
        "ROUTE": "settings_teams_edit_members",
        "BODY": "تعديل الوكلاء في فريقك."
      },
      "EDIT_WIZARD_FINISH": {
        "TITLE": "إنهاء",
        "ROUTE": "settings_teams_edit_finish",
        "BODY": "أصبح كل شيء جاهزاً الآن!"
      }
    },
    "TEAM_FORM": {
      "ERROR_MESSAGE": "تعذر حفظ تفاصيل الفريق. حاول مرة أخرى."
    },
    "AGENTS": {
      "AGENT": "وكيل",
      "EMAIL": "البريد الإلكتروني",
      "BUTTON_TEXT": "إضافة وكلاء",
      "ADD_AGENTS": "إضافة وكلاء إلى فريقك...",
      "SELECT": "حدد",
      "SELECT_ALL": "تحديد جميع الوكلاء",
      "SELECTED_COUNT": "تم تحديد {selected} من أصل {total} وكيل."
    },
    "ADD": {
      "TITLE": "إضافة وكلاء للفريق - {teamName}",
      "DESC": "إضافة وكلاء إلى فريقك الجديد. هذا يتيح لكم العمل كفريق في المحادثات، والحصول على إشعار عن الأحداث الجديدة في نفس المحادثة.",
      "SELECT": "حدد",
      "SELECT_ALL": "تحديد جميع الوكلاء",
      "SELECTED_COUNT": "تم تحديد {selected} من أصل {total} وكيل.",
      "BUTTON_TEXT": "إضافة وكلاء",
      "AGENT_VALIDATION_ERROR": "اختر وكيل واحد على الأقل."
    },
    "FINISH": {
      "TITLE": "أصبح فريقك جاهزة الآن!",
      "MESSAGE": "يمكنكم الآن العمل كفريق في المحادثات. دعم سعيد ",
      "BUTTON_TEXT": "إنهاء"
    },
    "DELETE": {
      "BUTTON_TEXT": "حذف",
      "API": {
        "SUCCESS_MESSAGE": "تم حذف الفريق بنجاح.",
        "ERROR_MESSAGE": "تعذر حذف الفريق. حاول مرة أخرى."
      },
      "CONFIRM": {
        "TITLE": "هل أنت متأكد من أنك تريد حذف هذا الفريق؟",
        "PLACE_HOLDER": "الرجاء كتابة {teamName} للتأكيد",
        "MESSAGE": "سيؤدي حذف الفريق إلى إزالة مهمة الفريق من المحادثات التي تم تعيينها لهذا الفريق.",
        "YES": "حذف ",
        "NO": "إلغاء"
      }
    },
    "SETTINGS": "الإعدادات",
    "FORM": {
      "UPDATE": "تحديث فريق",
      "CREATE": "إنشاء فريق جديد",
      "NAME": {
        "LABEL": "اسم الفريق",
        "PLACEHOLDER": "على سبيل المثال: المبيعات ، خدمة العملاء"
      },
      "DESCRIPTION": {
        "LABEL": "وصف الفريق",
        "PLACEHOLDER": "وصف مختصر لهذا الفريق."
      },
      "AUTO_ASSIGN": {
        "LABEL": "السماح بالتكليف التلقائي لهذا الفريق."
      },
      "SUBMIT_CREATE": "إنشاء فريق جديد"
    }
  }
}
